export default __webpack_public_path__ + "static/media/Background_00244.aa5d1142.png";